import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Button from '../../shared/Button/Button';
import routeConstant from '../../../lib/constants/routeConstant';
import token_unavailable from '../../../assets/images/token_unavailable.png';
import { MY_ACCOUNT_TABS } from '../../MyAccount/myAccountTabsData';
import { poweredUpScreen as styles } from '../deployToken.tailwind';
import Cube from '../../shared/Others/Cube/Cube';
import { getTokenDataById } from '../deployToken.data';
import { useSelector } from 'react-redux';

const PoweredUpScreen = ({ selectedTokenId, setSelectedTokenId, purchasedTokens, setMyAccountActiveTab, matchId, userId }) => {
    const navigate = useNavigate();
    const cubeContainer = useRef(null);
    const { currentSeason } = useSelector((state) => state.seasons);
    
    // selected token data is fetched through getTokenDataById function
    const data = getTokenDataById(selectedTokenId, purchasedTokens, matchId, userId, currentSeason?.actions, currentSeason?.homeTeam?.players);

    // Find the token data matching the selectedTokenId
    const isLastToken = selectedTokenId === purchasedTokens?.length - 1;

      const handleNext = () => {
        // const tokensLength = deployedTokens?.length;

        if (!isLastToken) {
          // If there are more tokens, increment the selectedTokenId
          const nextTokenId = selectedTokenId + 1;
          setSelectedTokenId(nextTokenId);
        }
      };

      const handleBack = () => {
        if (selectedTokenId > 0) {
            // Decrease the selectedTokenId if not at the first token
            const prevTokenId = selectedTokenId - 1;
            setSelectedTokenId(prevTokenId);
        }
    };

    const handleBackToHome = () => {
        navigate(routeConstant.MY_ACCOUNT_PAGE);
        setMyAccountActiveTab(MY_ACCOUNT_TABS.VIEW_GAMES)
    };

    return (
        <div className={styles.outerContainer}>
           <div className={styles.headerSection}> 
                <div className={styles.tokenDetails}>
                    <p className={styles.tokenDetailContainer}>#{data?.tokenName}</p>
                    <p className={styles.tokenDetailContainer}> {data?.isDeployed ? "Powered Up" : "Not Powered Up"}</p>
                </div>
                <Button variant='primary' onClick={handleBackToHome} className='ml-auto'>
                    <ArrowBackIosIcon
                        sx={{ md: { fontSize: "16px" }, fontSize: "11px" }}
                    />
                    <span className={styles.buttonText}>Back to My Account</span>
                </Button>
            </div>
            {data?.isDeployed ? (
                <div className={styles.detailsContainer} ref={cubeContainer} id='asd'>
                    <Cube 
                        actionImage={data?.actionImage} 
                        playerImage={data?.playerImage}
                        ref={cubeContainer} 
                    />
                    <div className={styles.deployedTokenDetails}>
                        <h1 className={styles.deployedTokenPlayerName}>{data?.playerName}</h1>
                        <h1 className={styles.deployedTokenActionName}>{data?.actionName}</h1>
                    </div>
                </div>
            ) : (
                <div className={styles.detailsContainer}>
                    <img src={token_unavailable} alt='Token Not Powered Up' className={styles.notDeployedImage}/>
                </div>
            )}
            <div className={styles.buttonContainer}>
                {selectedTokenId > 0 &&
                    <Button variant='primary' onClick={handleBack} disabled={selectedTokenId === 0}>Back</Button>
                }
                {!isLastToken &&
                    <Button variant='primary' onClick={handleNext} disabled={isLastToken} className='ml-auto'>Next</Button>
                }
            </div>
        </div>
    );
};

export default PoweredUpScreen;
